import { Expandable } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/Expandable";
import { FC } from "react";
import { CollapsedAssistanceItem } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/CollapsedAssistanceItem";
import { ExpandableHeaderContent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/ExpandableHeaderContent";
import { ExpandableBodyContent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/ExpandableBodyContent";
import { AssistanceEvent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/AssistanceType";

type AssistanceEventGridItemProps = {
  assistanceEvent: AssistanceEvent;
  collapsed: boolean;
};

export const AssistanceEventGridItem: FC<AssistanceEventGridItemProps> = ({
  assistanceEvent,
  collapsed,
}) =>
  collapsed ? (
    <CollapsedAssistanceItem assistanceEvent={assistanceEvent} />
  ) : (
    <Expandable
      asSubgrid
      headerContent={
        <ExpandableHeaderContent assistanceEvent={assistanceEvent} />
      }
    >
      <ExpandableBodyContent assistanceEvent={assistanceEvent} />
    </Expandable>
  );
